import React from 'react';
import NontificationContainer from "./NontificationContainer"
const Notification = (props) => (
    <NontificationContainer {...props} />
);
export default Notification;
